import styled from "styled-components";

export const Address = styled.div`
  p {
    margin-bottom: 0 !important;
  }
`;
